// extracted by mini-css-extract-plugin
module.exports = {"NoInvoice":"NoInvoice_NoInvoice__2OIAL","NoInvoice__heading":"NoInvoice_NoInvoice__heading__1a0lo","NoInvoice__para":"NoInvoice_NoInvoice__para__1DnVS"};